/** 
*@author: satyamurthy.a
*@Description : 
**/
import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import { message, Button, Drawer, Input, Popconfirm, Upload, Form, Modal, Select } from 'antd';
import { API_LANGUAGE, IPAddress, SAMPLE } from '../../../commons/api';
import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  UploadOutlined,
  PlusOutlined,
  DownloadOutlined,
  SaveOutlined
} from '@ant-design/icons';
import {
  _getTranslationMasterData,
  _saveTranslation,
  _getCurrentLanguages,
  _saveLangTranslation,
  _getTranslationData,
  _getTransFromKeyword,
  tranlateAllData,
  downloadApi
} from './translationCalls';

const Translation = (props) => {
  const [visible, setVisible] = useState(false);
  const [isLanguageModal, setIsLanguageModal] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [editObject, setEditObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const [languageList, setLanguageList] = useState([]);
  const [languageMasterList, setLanguageMasterList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [downloadName, setdownloadName] = useState('');
  // const [filename, setFilename] = useState('');
  const translationRef = useRef();
  const languageForm = useRef();
  const searchInputRef = useRef(null);

  useEffect(() => {
    _getTranslationList();
    _getLanguageMasterList();
    _getCurrentLanguage();
    downloadTranslationData();
  }, []);

  const downloadTranslationData = async () => {
    let filedownload = await downloadApi();
    setdownloadName(filedownload && filedownload.file ? filedownload.file : '');
  };
  const translation = (keyword) => {
    return props && props.translationCache && props.translationCache[keyword]
      ? props.translationCache[keyword]
      : keyword || '';
  };

  const _getTranslationList = async () => {
    try {
      const dataSource = await _getTranslationData();
      setDataSource(dataSource);
    } catch (error) {
      console.error('Error fetching translation list:', error);
    }
  };

  const _getLanguageMasterList = async () => {
    try {
      const dataSource = await _getTranslationMasterData();
      let listData = dataSource && Array.isArray(dataSource) && dataSource.map((langugae) => {
        return {
          label: langugae.Language,
          value: langugae.Language
        };
      });
      setLanguageMasterList(listData);
    } catch (error) {
      console.error('Error fetching translation list:', error);
    }
  };

  const _getCurrentLanguage = async () => {
    try {
      const languageList = await _getCurrentLanguages();
      const columnsAddition = languageList && Array.isArray(languageList) ?
        languageList.map((language) => ({
          title: () => <div>{language.Name}
            <SaveOutlined style={{ marginLeft: "10px" }} onClick={async () => {
              let data = await tranlateAllData(language.Name);
              if (data && data !== undefined && data.message) {
                message.success(data.message);
                _getTranslationList();
              }

            }} />
          </div >,
          dataIndex: language.Name,
          key: language.Name,
          width: '15%',
          ...getColumnSearchProps(language.Name),

        })) : [];

      const columns = [
        {
          title: translation('Keyword'),
          dataIndex: 'Keyword',
          key: 'Keyword',
          width: '15%',
          ...getColumnSearchProps('Keyword'),
        },
        ...columnsAddition,
        {
          title: translation('Action'),
          dataIndex: '',
          key: 'action',
          width: '15%',
          render: (text, record) => (
            <div>
              <Button type="primary" onClick={() => editTranslation(record)}>
                <EditOutlined />
              </Button>
              <Popconfirm
                title={translation('Do you want to delete ?')}
                onConfirm={() => deleteTranslation(record)}
                onCancel={handleCancel}
                okText={translation('Yes')}
                cancelText={translation('No')}>
                <Button type="primary" style={{ marginLeft: '10px' }}>
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </div>
          )
        }
      ];

      setLanguageList(languageList);
      setColumns(columns);
    } catch (error) {
      console.error('Error fetching current languages:', error);
    }
  };

  const editTranslation = (record) => {
    if (translationRef.current) {
      translationRef.current.setFieldsValue(record);
    }
    setEditObject(record);
    setVisible(true);
  };

  const openDrawer = () => {
    if (translationRef.current) {
      translationRef.current.resetFields();
    }
    setVisible(true);
    setEditObject({});
  };

  const onClose = () => {
    if (translationRef.current) {
      translationRef.current.resetFields();
    }
    setEditObject({});
    setVisible(false);
  };

  const saveTranslation = async (e) => {
    e.preventDefault();
    let { userProfile } = props;
    const SiteId = localStorage.get('currentSite');
    try {
      const values = await translationRef.current.validateFields();
      const saveTranslation = {
        ...values,
        SiteId,
        CreatedBy: userProfile && userProfile.user ? userProfile.user.Id : ""
      };
      await curdTranslationFn(saveTranslation, 'create', 'POST');
    } catch (error) {
      console.error('Error saving translation:', error);
    }
  };
  const onLanguageFinish = async () => {
    try {
      const values = await languageForm.current.validateFields();
      let payload = {
        Language: values && values.languageIds ? values.languageIds : []
      };
      let responseData = await _saveLangTranslation(payload);
      if (responseData && responseData.message) {
        message.success(responseData.message);
        _getCurrentLanguage();
        setIsLanguageModal(false);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const updateTranslation = async (e) => {
    e.preventDefault();
    let { userProfile } = props;
    const { Id } = editObject;
    const SiteId = localStorage.get('currentSite');

    try {
      const values = await translationRef.current.validateFields();
      const updateTranslation = {
        ...values,
        SiteId,
        Id,
        ModifiedBy: userProfile && userProfile.user ? userProfile.user.Id : ""
      };
      await curdTranslationFn(updateTranslation, 'update', 'PATCH');
      message.success(translation('Translation updated successfully'));
      onClose();
      _getTranslationList();
    } catch (error) {
      console.error('Error updating translation:', error);
    }
  };

  const curdTranslationFn = async (payload, apiURL, method) => {
    const responseData = await _saveTranslation(payload, apiURL, method);
    if (responseData && responseData.message) {
      await _getTranslationList();
      setVisible(false);
      setEditObject({});
      if (translationRef.current) {
        translationRef.current.resetFields();
      }
      message.success(responseData.message);
    }
  };

  const deleteTranslation = async (record) => {
    const SiteId = localStorage.get("currentSite");
    const deleteTranslation = {
      Keyword: record.Keyword,
      SiteId,
    };
    await curdTranslationFn(deleteTranslation, "delete", "POST");
    if (translationRef.current) {
      translationRef.current.resetFields();
    }
    setVisible(false);
    await _getTranslationMasterData();
  };
  const handleCancel = () => {
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}>
          {translation('Search')}
        </Button>
        <Button
          type="primary"
          onClick={() => {
            clearFilters();
            setSearchText('');
            handleSearch([''], confirm);
          }}

          style={{ width: 90 }}>
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select(), 0);
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]} // Ensure this is an array
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleFileChange = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
      _getTranslationList();
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };


  // const uploadProps = {
  //   name: 'file',
  //   action: '/upload', // Your upload endpoint
  //   onChange: handleFileChange,
  //   accept: '.csv,.xml'
  // };

  // const downloadFile = async () => {
  //   try {
  //     const response = await axios.get('/download/translation.csv', {
  //       responseType: 'blob'
  //     });
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', 'translation.csv');
  //     document.body.appendChild(link);
  //     link.click();
  //     message.success(translation('File downloaded successfully'));
  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //     message.error(translation('Failed to download file'));
  //   }
  // };

  const getTranslatedValueForKeyword = async () => {

    if (translationRef.current) {

      const values = await translationRef.current.validateFields();
      let res = await _getTransFromKeyword(values.Keyword);
      return { ...res, Keyword: values.Keyword };
    }
  };

  const onAutoPopulateClick = async () => {
    let translation = await getTranslatedValueForKeyword();
    translationRef.current.setFieldsValue({ ...translation });


  };

  const accessToken = localStorage.get('accessToken');
  // const Authorization = 'Bearer ' + accessToken;s
  const siteId = localStorage.get('currentSite');

  // const uploadProps = {
  //   name: 'file',
  //   file: filename,
  //   method: 'POST',
  //   action: `${API_LANGUAGE.BULK}?SiteId=${siteId}`,
  //   headers: {
  //     Authorization: Authorization
  //   },
  //   data: {
  //     file: filename
  //   },
  //   onChange: handleFileChange
  // };
  // const UploadMenu = (e) => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   let payload = {
  //     method: 'POST',
  //     url: `${API_LANGUAGE.BULK}?SiteId=${siteId}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     },
  //     data: e
  //   };

  //   axios(payload)
  //     .then((response) => {
  //       message.success(response.data.message);
  //       // if (info.file.status === 'done') {
  //       //   message.success(`${info.file.name} file uploaded successfully`);
  //         _getTranslationList();
  //       // } else if (info.file.status === 'error') {
  //       //   message.error(`${info.file.name} file upload failed.`);
  //       // }
  //       // if (translationRef.current) {
  //       //   translationRef.current.resetFields();
  //       // }
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //       return [];
  //     });
  // };
  const customRequest = async (options) => {
    const { file, onSuccess, onError } = options;

    // Create FormData and append file plus any extra data
    const formData = new FormData();
    formData.append('file', file);
    formData.append('extraField', 'extraValue'); // Add custom fields here

    try {
      const response = await fetch(`${API_LANGUAGE.BULK}?SiteId=${siteId}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`
          // Do NOT set 'Content-Type' header when sending FormData
        },
        body: formData,
      });

      if (response.ok) {
        onSuccess(await response.json(), file);
      } else {
        onError(new Error('Upload failed'));
      }
    } catch (err) {
      onError(err);
    }
  };

  return (
    <div
      style={{
        flexDirection: "row",
        justifyContent: "space-evenly",
      }}
    >

      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          marginBottom: "15px",
        }}
      >
        <Button type="primary" onClick={() => {
          if (languageForm.current) {
            languageForm.current.setFieldsValue({ languageIds: languageList && Array.isArray(languageList) && languageList.map((lang) => { return lang.Name; }) });
          }

          setIsLanguageModal(true);
        }} style={{ marginLeft: '5px' }}>
          <PlusOutlined /> {translation('Add/Modify languages')}
        </Button>
        <Button type="primary" onClick={openDrawer} style={{ marginLeft: '5px' }}>
          <PlusOutlined /> {translation('Add New Keyword')}
        </Button>
        <Button type="primary" style={{ marginLeft: '5px' }}>
          <DownloadOutlined />
          <a href={`${IPAddress.LOCAL}${SAMPLE.SampleCSV}`} style={{ color: 'white' }}>
            {translation('Default Template')}
          </a>
        </Button>
        <Upload
          customRequest={customRequest}
          onChange={handleFileChange}
          accept="csv/xml"
          multiple={false}
        >
          <Button type='primary'>
            <UploadOutlined /> {translation('Click to Upload')}
          </Button>
        </Upload>
        <Button type="primary"  style={{ marginRight: '5px' }}>
          <DownloadOutlined />
          <a href={`${IPAddress.LOCAL}${downloadName}`} style={{ color: 'white' }}>
              {translation('Download')}
            </a>
        </Button>
      </div>
      <StyledTable size="small"
        dataSource={
          dataSource && Array.isArray(dataSource) ?
            dataSource.map((data, index) => {
              return { key: index, ...data };
            }) : []
        }
        columns={columns}
        rowKey="Id"
        pagination={{ pageSize: 10 }}
        bordered
      />
      <Drawer
        title={translation('Translation')}
        width={500}
        onClose={onClose}
        open={visible}
      >

        <Form
          ref={translationRef}
          layout="vertical"
          onFinish={editObject.Keyword ? updateTranslation : saveTranslation}
        >
          <Form.Item name="Keyword" label={<div>
            {translation('Keyword')}
            <Button
              style={{ marginLeft: '10px' }}
              onClick={() => {
                onAutoPopulateClick();
              }}>Auto Populate</Button></div>} rules={[{ required: true }]}>
            <Input disabled={editObject.Keyword ? true : false} />
          </Form.Item>
          {languageList && Array.isArray(languageList) && languageList.map((language) => (
            <Form.Item key={language} name={language.Name} label={translation(language.Name)}>
              <Input />
            </Form.Item>
          ))}
        </Form>
        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          <Button type="primary" htmlType="submit" onClick={editObject.Keyword ? updateTranslation : saveTranslation}>
            {editObject.Keyword ? translation('Update') : translation('Save')}
          </Button>
        </DrawerFooter>
      </Drawer>
      <Modal title="Add/Modify Languages" open={isLanguageModal} onOk={() => {
        setIsLanguageModal(true);
        onLanguageFinish();
      }} onCancel={() => { setIsLanguageModal(false); }}>

        <Form
          layout="inline"
          ref={languageForm}
          initialValues={{ languageIds: languageList && Array.isArray(languageList) ? languageList : [] }}
          onFinish={onLanguageFinish}
        >
          <Form.Item label="Select Languages" name="languageIds" rules={[{ required: true }]}>
            <Select
              showSearch
              mode="multiple"
              style={{ width: '200px  ' }}
              placeholder="Please Languages"
              options={
                languageMasterList
              }
            />
          </Form.Item>
        </Form>

      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Translation);